var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeldInReserveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7587 23.2778H8.6476C5.31426 23.2778 3.09204 21.6111 3.09204 17.7222V9.94447C3.09204 6.05558 5.31426 4.38892 8.6476 4.38892H19.7587C23.092 4.38892 25.3143 6.05558 25.3143 9.94447V17.7222C25.3143 21.6111 23.092 23.2778 19.7587 23.2778Z",
    stroke: "#F2994A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2032 17.1667C16.0442 17.1667 17.5365 15.6743 17.5365 13.8333C17.5365 11.9924 16.0442 10.5 14.2032 10.5C12.3623 10.5 10.8699 11.9924 10.8699 13.8333C10.8699 15.6743 12.3623 17.1667 14.2032 17.1667Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09204 10.5H4.20315C7.53648 10.5 8.6476 9.3889 8.6476 6.05557V4.94446",
    stroke: "#F2994A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3143 10.5H24.2032C20.8699 10.5 19.7588 9.3889 19.7588 6.05557V4.94446",
    stroke: "#F2994A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09204 17.1666H4.20315C7.53648 17.1666 8.6476 18.2777 8.6476 21.6111V22.7222",
    stroke: "#F2994A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3143 17.1666H24.2032C20.8699 17.1666 19.7588 18.2777 19.7588 21.6111V22.7222",
    stroke: "#F2994A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeldInReserveIcon);
export default __webpack_public_path__ + "static/media/HeldInReserveIcon.06b9e845752463fd6ed5772dffe3492e.svg";
export { ForwardRef as ReactComponent };